import { type AdminDataProvider } from '../api/adminDataProvider';
import { queryOptions } from '@tanstack/react-query';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- used for docs
import type { useCurrentUser } from '../auth/currentUserContext';

/**
 * Fetches the current user from the admin data provider.
 *
 * You should probably use {@link useCurrentUser} instead, which uses the locally cached user.
 */
export const useFetchCurrentUser = (provider: AdminDataProvider) =>
  queryOptions({
    queryKey: ['currentUser'],
    queryFn: provider.fetchCurrentUser,
    staleTime: 1000 * 60,
  });
